import { Directive } from '@angular/core';
import { PwaInstallService } from '../services/pwa-install.service';

@Directive({ selector: '[appPwaInstall]', exportAs: 'pwaInstall' })
export class PwaInstallDirective {
  busy = false;

  constructor(private service: PwaInstallService) {}

  get isInstalled(): boolean { return this.service.isInstalled; }

  get errorKey(): string { return this.service.errorKey; }

  install(): void {
    if (this.busy) { return; }
    this.busy = true;
    this.service.install().then(() => this.busy = false);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/pwa-install.directive.ts